import { TCategory, TTopCategory } from 'data';
import { InstoreService, InstoreServiceGroup } from 'containers/instore/instore-service/types';
import { RatingData, TConfigurator } from 'containers/configurators-listing/types';

type TOffer = TCategory | InstoreService;

type TData = TTopCategory | InstoreServiceGroup | TConfigurator;

type TOfferType = 'categories' | 'services' | 'configurators';

export const getOffers = (data: TData[], offerType: TOfferType) => {
	if (offerType === 'configurators') {
		return data;
	}
	const offers = data.reduce((acc, element) => {
		if (element[offerType]?.length) {
			return [...acc, ...element[offerType]];
		}
		return acc;
	}, [] as TOffer[]);

	return offers;
};

export const getOffersCount = (offers: TOffer[]) => offers.length;

export const getPrices = (offers: InstoreService[] | TCategory[] | TConfigurator[]) =>
	offers.map(offer => offer.price).filter(price => price); // фильтруем возможный null (согласно проекту) в инсторах

export const getMinPrice = (prices: number[]) => Math.min(...prices);
export const getMaxPrice = (prices: number[]) => Math.max(...prices);

export const getOfferData = (data: TData[], offerType: TOfferType) => {
	if (!data?.length) {
		return null;
	}

	const offers = getOffers(data, offerType);
	const prices = getPrices(offers);
	return {
		offerCount: getOffersCount(offers),
		lowPrice: getMinPrice(prices),
		highPrice: getMaxPrice(prices),
	};
};

export const getAggregateRating = (rating: RatingData[]) => {
	if (!rating.length) {
		return { ratingValue: '5', reviewCount: '5' };
	}

	let reviewCount = 0;
	let summaryRating = 0;
	let ratingsCount = 0;

	rating.forEach(({ avgRating, totalReviews }) => {
		reviewCount += totalReviews;
		summaryRating += avgRating;
		if (totalReviews && avgRating) {
			ratingsCount++;
		}
	});

	return {
		ratingValue: summaryRating > 0 ? (summaryRating / ratingsCount).toFixed(1) : '5',
		reviewCount: reviewCount || 5,
	};
};

const INSTORES = [
	'analiz-vody',
	'kolerovka',
	'overlok',
	'poshiv-shtor',
	'rezka-dereva',
	'rezka-stekla',
];

export const isInstorePage = (url: string) => {
	return INSTORES.filter(instore => url.indexOf(instore) >= 0).length > 0;
};
